export default __webpack_public_path__ + "static/724 Market_logo-5994b657971b45f1976c4814b7674778.png";